import { Typography } from '@mui/material';
import React from 'react';
import {
  configValueLabels,
  cronJobLabels,
  CronJobStatus,
  TaskType,
} from 'src/api/hooks/useConfigs.types';
import { CronStatusIcon } from 'src/components/Cron';
import { ConfigValueCellProps } from 'src/components/Config/ConfigValueCell.types';
import { FacebookTokenDisplay } from 'src/components/FacebookToken/FacebookToken';

export const ConfigValueCell: React.FC<ConfigValueCellProps> = ({
  row,
  expiresAt,
  renewedToken,
  renewAccessTokenLoading,
}) => {
  const { value, name } = row;

  if (Object.values(cronJobLabels).includes(name)) {
    return <CronStatusIcon isEnabled={value === CronJobStatus.ENABLED} />;
  }

  if (name === configValueLabels[TaskType.DellaFacebookAccessToken]) {
    return (
      <FacebookTokenDisplay
        token={renewedToken}
        expiresAt={expiresAt}
        renewAccessTokenLoading={renewAccessTokenLoading}
      />
    );
  }

  return <Typography sx={{ cursor: 'pointer' }}>{value}</Typography>;
};
